import axios from "axios";
import merge from 'deepmerge'
import md5 from 'md5'

// const api = process.env.NODE_ENV === "production" ? "/" : "/api/";

// 根据环境 添加对应url

// 设置请求超时 60秒
const instance = axios.create({
  timeout: 60000
});

// console.log(window.location, 1111)
// console.log(process.env.NODE_ENV, 2222)
if (process.env.NODE_ENV === "production") {
  instance.defaults.baseURL = window.location.origin + "/";
} else {
  instance.defaults.baseURL = "/api/";
}
axios.defaults.headers.post["Content-type"] = "application/json,charset=UTF-8";

// Add a request interceptor
// 添加请求拦截器

instance.interceptors.request.use(
  config => {
    // console.log(config)
    let data = {}
    config.headers['x-timestamp'] = Date.parse(new Date()) / 1000

    data = merge(data, getUrlParams(config.url))
    if (config.data !== undefined) {
      if (typeof config.data === 'string') {
        data = merge(data, getUrlParams(config.data))
      } else {
        data = merge(data, config.data)
      }
    }
    if (config.params !== undefined) {
      data = merge(data, config.params)
    }
    config.headers['x-sign'] = getSign(ksort(data), config.headers['x-timestamp']);
    if (config.method == 'post') {
      config.data = config.data || {}
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
// 添加响应拦截器

axios.interceptors.response.use(
  response => {
    // do something with response data
    // 在发送请求之前做些什么
    if (response.status === 200) {
      return Promise.resolve(response)
    }
  },
  error => {
    // do something with response error
    return Promise.reject(error);
  }
);

// 获取签名
function getSign(data, timestamp) {
  let paramPattern = ''
  let key = 'kami-supply-shop-pc'
  for (const key in data) {
    if (data[key] !== null && data[key] !== '') paramPattern += `&${key}=${data[key]}`
  }
  paramPattern = paramPattern.substr(1)
  return md5(key + timestamp + paramPattern)
}

// 对象排序
function ksort(arys) {
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newkey = Object.keys(arys).sort()
  //创建一个新的对象，用于存放排好序的键值对
  var newObj = {};
  for (var i = 0; i < newkey.length; i++) {
    //遍历newkey数组
    newObj[newkey[i]] = arys[newkey[i]]
    //向新创建的对象中按照排好的顺序依次增加键值对
  }
  //返回排好序的新对象
  return newObj
}

function getUrlParams(url) {
  let data = {}
  if (url === '') return data;
  const url_params = url.slice(url.indexOf('?') + 1)
  let url_array = url_params.split('&')
  for (const item of url_array) {
    let key_value = item.split('=')
    data[key_value[0]] = key_value[1]
  }
  return data
}

export default instance;



// WEBPACK FOOTER //
// ./src/utils/require.js